/* EVENTS INVOLVING USERS  */

module.exports = {
  user_login_attempt_initiated: {
    excludeSuperAdmin: true,
    getProps: ({ flow_type }) => {
      return {
        flow_type: flow_type,
      };
    },
  },
  user_login_auth_method_presented: {
    excludeSuperAdmin: true,
    getProps: ({ auth_method_presented }) => {
      return {
        auth_method_presented: auth_method_presented,
      };
    },
  },
  user_authentication_initiated: {
    excludeSuperAdmin: true,
    getProps: ({ auth_method, flow_type }) => {
      return {
        auth_method: auth_method,
        flow_type: flow_type,
      };
    },
  },
  registration_request_to_join_presented: {
    excludeSuperAdmin: true,
    getProps: ({}) => {
      return {};
    },
  },
  user_access_alert_presented: {
    excludeSuperAdmin: true,
    getProps: ({ alert_type }) => ({
      alert_type: alert_type,
    }),
  },
};
